module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Ajouter des bagages en option","no-options-for-outward":"Pas d\u0027options disponibles pour l\u0027aller","no-options-for-return":"Pas d\u0027options disponibles pour le retour"},"en":{"title":"Add luggage option","no-options-for-outward":"No options available for the outward journey","no-options-for-return":"No options available for the return journey"}}')
  delete Component.options._Ctor
}
